<div class="container-pagina-areas">

    <app-menu></app-menu>

    <router-outlet></router-outlet>

</div>
